import apiClient from '../../../shared/services/apiClient';

export const invitesAPI = {
  list: (businessId) => apiClient.get(`/business-invites/business/${businessId}`),
  listMembers: (businessId) => apiClient.get(`/business-invites/business/${businessId}/members`),
  updateMemberDivisions: (businessId, userId, state_registration_ids) =>
    apiClient.put(`/business-invites/business/${businessId}/members/${userId}/divisions`, {
      state_registration_ids
    }),
  updateMemberBankFeeds: (businessId, userId, permissions) =>
    apiClient.put(`/business-invites/business/${businessId}/members/${userId}/bank-feeds`, { permissions }),
  create: (businessId, data) => apiClient.post(`/business-invites/business/${businessId}`, data),
  pending: () => apiClient.get('/business-invites/pending'),
  accept: (token) => apiClient.post('/business-invites/accept', { token }),
  revoke: (token) => apiClient.delete(`/business-invites/${token}`),
  myScopes: () => apiClient.get('/business-invites/me/scopes')
};

export default invitesAPI;
